<script setup>
import { useRouter } from "vue-router";
import { useInvoiceStore } from "@/stores/invoice";

defineProps({
  items: {
    type: Array,
    default: () => [],
  },
});

const router = useRouter();
const invoiceStore = useInvoiceStore();

// ✅ FIX: ค้นหา invoice id จาก invoiceNo แล้ว navigate
const handleViewInvoice = (item) => {
  // dashboard store ใช้ id เป็น invoiceNo string (เช่น "INV-2026-0001")
  const invoice = invoiceStore.invoices.find(
    (inv) => inv.invoiceNo === item.id,
  );
  if (invoice?.id) {
    router.push(`/invoices/${invoice.id}`);
  }
};

const formatCurrency = (value) => {
  return new Intl.NumberFormat("th-TH", {
    style: "currency",
    currency: "THB",
    minimumFractionDigits: 0,
  }).format(value);
};

const badgeClass = (status) => {
  const classes = {
    paid: "text-bg-success",
    pending: "text-bg-secondary",
    overdue: "text-bg-danger",
    partial: "text-bg-warning",
  };
  return classes[status] || "text-bg-light";
};

const statusText = (status) => {
  const labels = {
    paid: "ชำระแล้ว",
    pending: "รอชำระ",
    overdue: "เกินกำหนด",
    partial: "ชำระบางส่วน",
  };
  return labels[status] || status;
};
</script>

<template>
  <div class="card border-0 shadow-sm rounded-4 h-100">
    <div class="card-body p-4">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <div>
          <h5 class="fw-bold mb-1">ใบแจ้งหนี้ล่าสุด</h5>
          <div class="text-muted small">
            รายการใบแจ้งหนี้ที่เพิ่งสร้างล่าสุด
          </div>
        </div>
        <!-- ✅ FIX: ลิงก์ไปหน้า invoice list -->
        <button
          class="btn btn-outline-primary btn-sm rounded-3"
          @click="router.push('/invoices')"
        >
          <i class="bi bi-search me-1"></i>ดูทั้งหมด
        </button>
      </div>

      <div class="table-responsive">
        <table class="table align-middle mb-0">
          <thead class="table-light">
            <tr>
              <th>เลขที่บิล</th>
              <th>ยูนิต</th>
              <th>ลูกบ้าน</th>
              <th class="text-end">ยอดเงิน</th>
              <th>สถานะ</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="invoice in items"
              :key="invoice.id"
              class="clickable-row"
              @click="handleViewInvoice(invoice)"
            >
              <td class="fw-semibold">{{ invoice.id }}</td>
              <td>{{ invoice.unitNo }}</td>
              <td>{{ invoice.residentName }}</td>
              <td class="text-end">{{ formatCurrency(invoice.amount) }}</td>
              <td>
                <span
                  class="badge rounded-pill"
                  :class="badgeClass(invoice.status)"
                >
                  {{ statusText(invoice.status) }}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<style scoped>
.clickable-row {
  cursor: pointer;
  transition: background-color 0.15s ease;
}
.clickable-row:hover {
  background-color: rgba(13, 110, 253, 0.04);
}
</style>
